import Http from "./http";

export const getTermsAndConditionsDetailsAPI = (payload, options) => {
  return Http.post("admin/campaign/terms-condition/get", payload, options);
};

